import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import PhysicalPackageForm from './PhysicalPackageForm'

const PhysicalPackageCreate: React.FC = () => (
  <SectionWrapper title={'resources.physicalpackages.createPackage'}>
    <Create>
      <PhysicalPackageForm />
    </Create>
  </SectionWrapper>
)

export default PhysicalPackageCreate
